/**
 * Central copy file — all hardcoded user-facing strings in one place.
 * Import the relevant namespace wherever you need text.
 */

export const COPY = {
  nav: {
    cta: 'Entre em contato',
    openMenu: 'Abrir menu',
    closeMenu: 'Fechar menu',
    mobileMenuLabel: 'Menu mobile',
  },

  footer: {
    builtBy: 'Desenvolvido por',
    agencyName: 'Include',
  },

  articles: {
    viewAll: 'Ver todos os artigos →',
  },

  articleCard: {
    readMorePrefix: 'Ler mais sobre', // used in aria-label: `Ler mais sobre ${title}`
    readingTime: (min: number) => `${min} min de leitura`,
  },

  blog: {
    listing: {
      heading: 'Artigos',
      empty: 'Nenhum artigo disponível.',
      noResults: 'Nenhum artigo encontrado para este filtro.',
    },
    filters: {
      regionLabel: 'Filtros do blog',
      filterByTag: 'Filtrar por tema',
      allTags: 'Todos',
      searchPlaceholder: 'Pesquisar artigos…',
      searchLabel: 'Pesquisar artigos',
      clearSearch: 'Limpar pesquisa',
      count: (filtered: number, total: number) =>
        filtered === total
          ? `${total} ${total === 1 ? 'artigo encontrado' : 'artigos encontrados'}`
          : `${filtered} de ${total} ${total === 1 ? 'artigo' : 'artigos'}`,
    },
    pagination: {
      navLabel: 'Paginação',
      prevLabel: 'Página anterior',
      prevText: '← Anterior',
      nextLabel: 'Próxima página',
      nextText: 'Próxima →',
      pageLabel: (p: number) => `Página ${p}`,
    },
    detail: {
      breadcrumbLabel: 'Breadcrumb',
      breadcrumbHome: 'Início',
      breadcrumbBlog: 'Blog',
      sidebarLabel: 'Conteúdo relacionado',
      relatedArticles: 'Artigos relacionados',
      adjacentNavLabel: 'Artigos anterior e próximo',
      prevArticleLabel: (title: string) => `Artigo anterior: ${title}`,
      prevArticleText: '← Artigo anterior',
      nextArticleLabel: (title: string) => `Próximo artigo: ${title}`,
      nextArticleText: 'Próximo artigo →',
      footerTagsHeading: 'Temas relacionados:',
      readingTime: (min: number) => `${min} min de leitura`,
    },
  },

  contact: {
    phoneLabel: 'WhatsApp / Telefone',
    emailLabel: 'E-mail',
    locationLabel: 'Atendimento',
    form: {
      submit: 'Enviar mensagem',
      submitting: 'Enviando…',
      success: 'Mensagem enviada! Entraremos em contato em breve.',
      error: 'Ocorreu um erro ao enviar. Tente novamente.',
    },
  },

  reviews: {
    googleLabel: 'no Google',
    viewReviews: 'Ver avaliações',
    prevLabel: 'Avaliações anteriores',
    nextLabel: 'Próximas avaliações',
    navLabel: 'Navegar avaliações',
    groupLabel: (i: number, total: number) => `Grupo ${i} de ${total}`,
    starsLabel: (n: number) => `${n} estrelas`,
    ratingLabel: (avg: string) => `Avaliação ${avg} no Google`,
  },

  validation: {
    required: 'Este campo é obrigatório',
    invalidEmail: 'E-mail inválido',
    invalidPhone: 'Telefone inválido',
    invalidName: 'Informe o nome completo',
  },
} as const;
